import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
// Side-effect import wires i18next before first render (politis does this in
// index.js). Must precede App so t(...) resolves on the first paint.
import './i18n/config'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
